import { useMemo } from "react";
import { t } from "@/i18n-js/instance";
import { Form } from "@/react/components/shared/uikit/Form";
import { localeRoot } from "../../../../constants";
import { FieldContainer } from "../../../components/FieldContainer";
import { FieldWithCounter } from "../../Fields/FieldWithCounter";

interface BenefitFormProps {
  keyFormId: string;
  name: string;
}

const dataTestId = "paywall-customization-benefit-fields";
const defaultFieldClassName = "!mt-0 !py-0";
const localeFields = "builder.benefits.fields";
const translationRoot = [localeRoot, localeFields].join(".");

const maxTitleLength = 50;
const maxDescriptionLength = 280;

const generateNameFields = (name: string) => ({
  title: [name, "title"].join("."),
  description: [name, "description"].join("."),
  icon: [name, "icon"].join("."),
});

export const BenefitForm = ({ keyFormId, name }: BenefitFormProps) => {
  const fields = useMemo(() => generateNameFields(name), [name]);

  return (
    <FieldContainer dataTestId={dataTestId}>
      <FieldWithCounter
        name={fields.title}
        label={t([translationRoot, "title"])}
        maxLength={maxTitleLength}
        errorMessage={t([translationRoot, "errors.title_max_length"])}
      >
        <Form.Item
          className={defaultFieldClassName}
          name={fields.title}
          translationRoot={translationRoot}
          hideLabel
          hidePlaceholder
          hideBorder
          hideDescription
          rules={{
            maxLength: {
              value: maxTitleLength,
              message: t([translationRoot, "errors.title_max_length"]),
            },
          }}
          variant="extra-bottom-margin"
        >
          <Form.Input
            key={keyFormId}
            prefix={
              <Form.EmojiPickerV3Wrapper
                name={fields.icon}
                className="!w-[3rem]"
              />
            }
          />
        </Form.Item>
      </FieldWithCounter>
      <FieldWithCounter
        name={fields.description}
        label={t([translationRoot, "description"])}
        maxLength={maxDescriptionLength}
        errorMessage={t([translationRoot, "errors.description_max_length"])}
      >
        <Form.Item
          className={defaultFieldClassName}
          name={fields.description}
          translationRoot={translationRoot}
          placeholder={t([translationRoot, "description_placeholder"])}
          hideBorder
          hideLabel
          fullWidth={false}
          hideDescription
          rules={{
            maxLength: {
              value: maxDescriptionLength,
              message: t([translationRoot, "errors.description_max_length"]),
            },
          }}
        >
          <Form.TextArea key={keyFormId} name={fields.description} />
        </Form.Item>
      </FieldWithCounter>
    </FieldContainer>
  );
};
